export const ROUTE_MAPPING = {
	MAP_RESULT: 'map.result',
	MAP_TRAFFIC: 'map.traffic',
	HOME_PAGE: 'homepage',
	RESTAURANT_DATASHEET: 'restaurant.datasheet',
	ACCOMMODATION_DATASHEET: 'accommodation.datasheet',
	TOURISM_DATASHEET: 'tourism.datasheet',
	SERVICE_GAS_STATION_DATASHEET: 'gasStation.datasheet',
	EV_SERVICE_DATASHEET: 'ev.datasheet',
	PARKING_DATASHEET: 'parking.datasheet',
	REST_STOP_DATASHEET: 'restStop.datasheet',
	PARTNER_DATASHEET: 'partner.datasheet',
	PARTNER2_DATASHEET: 'partner.datasheet',
	POI_FILTER: 'poi.filter',
	ITINERARY_SEARCH: 'itinerary.search',
	ITINERARY_DETAILS: 'itinerary.details',
	ITINERARY_RESULT: 'itinerary.result',
	ROUTE_COST: 'route.cost',
	ROUTE_EXPENSE: 'route.expense',
	ROUTE_EXPENSE_EDIT: 'route.expense.edit',
	ROUTE_EXPENSE_PRINT: 'route.expense.print',
	ROUTE_ROADSHEET: 'route.roadsheet',
	ROUTE_ON_THE_WAY: 'route.on-the-way',
	ROUTE_ON_THE_WAY_FILTER: 'route.on-the-way.filter',
	ROUTE_EXPLORATION: 'route.exploration',
	ROUTE_EXPLORATION_FREE: 'route.exploration.free',
	ROUTE_EXPLORATION_ZOI: 'route.exploration.zoi',
	ROUTE_RECOMMENDATIONS: 'route.recommendations',
	ADD_VEHICLE: 'add.vehicle',
	PROFILE_INFORMATION: 'profile.information',
	PROFILE_SETTINGS: 'profile.settings',
	PROFILE_AUTHENTIFICATION: 'profile.authentication',
	PROFILE_ANIMATION: 'profile.animation',
	PROFILE_FAVORITES: 'profile.iti_favorites',
	ROUTE_ZOI_SETTINGS: 'route.zoi.settings',
} as const;

export type RouteKey = keyof typeof ROUTE_MAPPING;
export type Pagename = typeof ROUTE_MAPPING[RouteKey];

export const routesPagename: Record<RouteKey, Pagename> = ROUTE_MAPPING;
export const APP_PAGENAMES = Object.values(ROUTE_MAPPING) as Pagename[];
